import ja from 'date-fns/locale/ja';
import { CONST_DEL_SUBMENU_TITLE_FILTER } from 'features/SubTitleMenu/constans';
import { FormEvent, forwardRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { formatDate } from 'utils';
registerLocale('ja', ja);
interface FilterProps {
  setName: (name: string) => void;
  handleFilter: (e: FormEvent) => void;
  setDeleteFlg?: (deleteFlg: number) => void;
  setExpiredDate: (expiredDate: Date) => void;
  name?: string;
  code?: string;
  menuPos?: string;
  setCode: (code: string) => void;
  deleteFlg: number;
  expiredDate: Date;
  setMenuPos: (menuPos: string) => void;
}

const deleteFlgString: any = {
  '0': '削除データのみ表示',
  '1': '削除データ非表示',
  '-1': '削除データ含めて表示',
};

function Filter({
  setName,
  handleFilter,
  setDeleteFlg,
  setExpiredDate,
  setCode,
  name,
  code,
  expiredDate,
  deleteFlg,
  menuPos,
  setMenuPos,
}: FilterProps) {
  const { t } = useTranslation();

  function handleChangeName(event: any) {
    setName(event.target.value);
  }

  function handleChangeDelFlg(event: any) {
    setDeleteFlg && setDeleteFlg(event.target.value);
  }

  function handleChangeCode(event: any) {
    setCode(event.target.value);
  }

  const handleChangeExpiredDate = (date: Date) => {
    setExpiredDate(date);
  };
  return (
    <Form onSubmit={handleFilter}>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>絞り込み条件</Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col sm={4} style={{ borderRight: '1px solid #ddd' }}>
                <Row className="mb-2">
                  <Col sm={4} className="text-end">
                    <Form.Label htmlFor="chk-menu-type" className="col-form-label">
                      {t('SubTitleMenu.Filter.order_type')}
                    </Form.Label>
                  </Col>
                  <Col sm={6} className="d-flex align-items-center">
                    <Form.Check
                      inline
                      defaultChecked={true}
                      type="radio"
                      label={t('SubTitleMenu.Filter.only_menu_child')}
                      id="chk-menu-type"
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={4} className="text-end">
                    <Form.Label htmlFor="txt-menu-name" className="col-form-label">
                      {t('SubTitleMenu.Filter.name')}
                    </Form.Label>
                  </Col>
                  <Col sm={4}>
                    <Form.Control type="text" onChange={handleChangeName} id="txt-menu-name" />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={4} className="text-end">
                    <Form.Label htmlFor="txt-menu-code" className="col-form-label">
                      {t('SubTitleMenu.Filter.code')}
                    </Form.Label>
                  </Col>
                  <Col sm={4}>
                    <Form.Control type="text" onChange={handleChangeCode} id="txt-menu-code" />
                  </Col>
                </Row>
              </Col>
              <Col sm={4} style={{ borderRight: '1px solid #ddd' }}>
                <Row className="mb-2">
                  <Col sm={4} className="text-end">
                    <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.filter_delete')}</Form.Label>
                  </Col>
                  <Col sm={6}>
                    <div style={{ paddingTop: '4px' }}>
                      <Form.Check
                        defaultChecked={true}
                        type="radio"
                        label={t('SubTitleMenu.Filter.hide_record_is_delete')}
                        id="3"
                        onChange={handleChangeDelFlg}
                        name="delete_flg"
                        value={CONST_DEL_SUBMENU_TITLE_FILTER.HIDE_DEL}
                      />
                      <Form.Check
                        type="radio"
                        label={t('SubTitleMenu.Filter.include_record_is_delete')}
                        id="4"
                        onChange={handleChangeDelFlg}
                        name="delete_flg"
                        value={CONST_DEL_SUBMENU_TITLE_FILTER.ALL}
                      />
                      <Form.Check
                        type="radio"
                        label={t('SubTitleMenu.Filter.show_record_is_delete')}
                        id="5"
                        onChange={handleChangeDelFlg}
                        name="delete_flg"
                        value={CONST_DEL_SUBMENU_TITLE_FILTER.SHOW_DEL}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm={4}>
                <Row className="mb-2">
                  <Col sm={4} className="text-end">
                    <div className="col-form-label">{t('SubTitleMenu.Filter.date_of_expiry')}</div>
                  </Col>
                  <Col sm={6}>
                    <Form.Label className="col-form-label">
                      {t('SubTitleMenu.Filter.Show_valid_dates_below')}
                    </Form.Label>
                    <div style={{ maxWidth: '138px' }}>
                      <ReactDatePicker
                        locale="ja"
                        selected={expiredDate}
                        onChange={handleChangeExpiredDate}
                        customInput={<CustomInputDatePicker readonly />}
                        dateFormat="yyyy/MM/dd"
                      />
                    </div>
                  </Col>
                </Row>
                <fieldset className="border px-3 mb-2">
                  <legend className="float-none small w-auto px-3">
                    {t('MenuList.Filter.related_cash_register_information')}
                  </legend>
                  <div className="ps-3 mb-2">
                    {t('MenuList.Filter.extract_the_menu_from_the_related_cash_register_information')}
                  </div>
                  <div style={{ marginLeft: '-1rem', marginRight: '-1rem' }}>
                    <Row className="mb-3">
                      <Col sm={4} className="text-end">
                        <Form.Label htmlFor="txt-pos" className="col-form-label">
                          {t('MenuList.Filter.pos')}：
                        </Form.Label>
                      </Col>
                      <Col sm={4}>
                        <FormControl
                          id="menu_pos"
                          type="text"
                          name="menu_pos"
                          onChange={(e) => {
                            setMenuPos(e.target.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                </fieldset>
                <div className="text-end">
                  <button type="submit" className="btn btn-primary">
                    {t('SubTitleMenu.Button.search')}
                  </button>
                </div>
              </Col>
            </Row>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.order_type')}</Form.Label>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.only_menu_child')}</Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.name')}</Form.Label>
                <Form.Label className="col-form-label">{name && name.length > 0 ? name : '-'}</Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.code')}</Form.Label>
                <Form.Label className="col-form-label">{code && code.length > 0 ? code : '-'}</Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.filter_delete')}</Form.Label>
                <Form.Label className="col-form-label">{deleteFlgString[deleteFlg.toString()]}</Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SubTitleMenu.Filter.date_of_expiry')}</Form.Label>
                <Form.Label className="col-form-label">{formatDate(expiredDate)}</Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('MenuList.Filter.pos')}：</Form.Label>
                <Form.Label className="col-form-label">{menuPos && menuPos.length > 0 ? menuPos : '-'}</Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </Form>
  );
}

const CustomInputDatePicker = forwardRef((props: any, ref: any) => {
  // You can style this further
  return (
    <>
      <div style={{ position: 'relative' }}>
        <FaCalendarAlt style={{ position: 'absolute', top: '8px', left: '10px' }} onClick={props.onClick} />
        <input
          className="form-control text-center"
          onClick={props.onClick}
          style={{ paddingLeft: '32px' }}
          value={props.value}
          onChange={props.onChange}
          type="text"
          readOnly={props.readonly}
        />
      </div>
    </>
  );
});

export default Filter;
